'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './housing_protection.routes';

export class HousingProtectionComponent {
  /*@ngInject*/
  constructor($state, $scope, $rootScope, fetch, lookup, FileUploadService, userService, $timeout, $http, baseConfigService, $stateParams) {
    this.$scope = $scope;
    const vm = this;
    this.fetch = fetch;
    this.$state = $state;
    this.lookup = lookup;
    this.$timeout = $timeout;
    this.userService = userService;
    this.baseConfigService = baseConfigService;
    this.$stateParams = $stateParams;
    this.FileUploadService = FileUploadService;
    this.$http = $http;


    $scope.adminUnlocked = false; // track admin manual unlock  
    $scope.formsSubmitData = [];
    $scope.currentlySelectedPolicies = [];
    $scope.pdfUrls = {
      'Tenant Anti-Harassment Protections': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Tenant_Anti-Harassment_Protections.pdf',
      'Just Cause Eviction': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Just_Cause.pdf',
      'No Net Loss and Right to Return to Demolished Homes': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/No_Net_Loss.pdf',
      'Legal Assistance for Tenants': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Legal_Assistance.pdf',
      'Foreclosure Assistance': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Foreclosure_Assistance.pdf',
      'Rental Assistance Program': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Rental_Assistance.pdf',
      'Rent Stabilization': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Rent_Stabilization.pdf',
      'Preventing Displacement from Substandard Condition (Protection)': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Protection_Substandard_Conditions.pdf',
      'Tenant Relocation Assistance': 'https://dsa-public-files.s3.us-west-2.amazonaws.com/Tenant_Relocation.pdf'
    }
    $scope.attachmentData = $scope.attachmentData || {};
    $scope.pendingChanges = false;
    $scope.savemode = 'housing';
    $scope.housingType = 'Protection';
    $scope.policyNotesMapping = {
      'Development Certainty and Streamlined Entitlement Process': '<strong>Note:</strong> Production Policy 3 (Affordable Housing Overlay Zones), Production Policy 5 (Ministerial Approval), and Production Policy 7 (Development Certainty and Streamlined Entitlement Process) are related and contain overlapping requirements. As a result, jurisdictions may only count one of these policies for the purpose of TOC compliance for production policies. However, if a jurisdiction implements all provisions from SB 330/SB 8 without a sunset date, then the jurisdiction meets the standards required by and can claim credit for both Production Policy 7 (Development Certainty and Streamlined Entitlement Process) and Protection Policy 2 (No Net Loss and Right to Return to Demolished Homes)',
      'Affordable Housing Overlay Zone': '<strong>Note:</strong> Production Policy 3 (Affordable Housing Overlay Zones), Production Policy 5 (Ministerial Approval), and Production Policy 7 (Development Certainty and Streamlined Entitlement Process) are related and contain overlapping requirements. As a result, jurisdictions may only count one of these policies for the purpose of TOC compliance for production policies.',
      'Affordable Housing Funding': '<strong>Note:</strong> A jurisdiction whose policy meets the minimum requirements above cannot also count this policy for credit for Production Policy 2 (Affordable Housing Funding). However, if a jurisdiction establishes a funding program that meets requirements for Production Policy 2, and if this program additionally has set asides for public/community land trusts that meet the funding listed in Appendix B, then the program can also receive credit toward Production Policy 6 (Public/Community Land Trusts). For example, a Tier A jurisdiction that has a production program with $2,000,000 in secured funding during the relevant four-year OBAG cycle would receive credit for both Production Policy 1 and Production Policy 6 if the program has a set aside for CLTs of $1,000,000, as these amounts meet the $1,000,000 four-year minimum for both policies.',
      'Public/Community Land Trusts': '<strong>Note:</strong> A jurisdiction whose policy meets the minimum requirements above cannot also count this policy for credit for Production Policy 2 (Affordable Housing Funding). However, if a jurisdiction establishes a funding program that meets requirements for Production Policy 2, and if this program additionally has set asides for public/community land trusts that meet the funding listed in Appendix B, then the program can also receive credit toward Production Policy 6 (Public/Community Land Trusts). For example, a Tier A jurisdiction that has a production program with $2,000,000 in secured funding during the relevant four-year OBAG cycle would receive credit for both Production Policy 1 and Production Policy 6 if the program has a set aside for CLTs of $1,000,000, as these amounts meet the $1,000,000 four-year minimum for both policies.',
      'Ministerial Approval': '<strong>Note:</strong> Production Policy 3 (Affordable Housing Overlay Zones), Production Policy 5 (Ministerial Approval), and Production Policy 7 (Development Certainty and Streamlined Entitlement Process) are related and contain overlapping requirements. As a result, jurisdictions may only count one of these policies for the purpose of TOC compliance for production policies.'
    }
    $scope.baseUrl = baseConfigService.getBaseURL();

    $scope.setPending = function () {
      $scope.savemode = 'housing';
      $scope.pendingChanges = true;
    }

    $scope.openPdf = function (item) {
      let pdfUrl = $scope.pdfUrls[item.housing_policy_name]

      if (pdfUrl) {
        window.open(pdfUrl, '_blank');
      } else {
        console.error(`PDF URL not found for policy: ${item.housing_policy_name}`);
      }
    };

    $scope.isFormEditable = function () {
      if (!$scope.currentPolicy) return true;

      var role = $scope.currentUser && $scope.currentUser.role;

      // Find matching submission status for current policy
      var submission = null;
      if ($scope.housingStatus) {
        for (var i = 0; i < $scope.housingStatus.length; i++) {
          if ($scope.housingStatus[i].housing_policy_name === $scope.currentPolicy.housing_policy_name) {
            submission = $scope.housingStatus[i];
            break;
          }
        }
      }

      // Not yet submitted — allow editing
      if (!submission || !submission.submitted) return true;

      // Admins can edit if they've manually unlocked
      if (role === 'Administrator') {
        return $scope.adminUnlocked;
      }

      // Admin set it to "Needs Work" — allow editing without withdraw
      if (submission.status === 'Needs Work') return true;

      // Otherwise submitted and locked — user must withdraw to edit
      return false;
    };

    $scope.$watch(
      function () {
        return $scope.currentPolicy && $scope.currentPolicy.housing_policy_name;
      },
      function () {
        $scope.adminUnlocked = false;
        $scope.formReadOnly = !$scope.isFormEditable();
        $scope.withdrawnNotice = false;
        $scope.needsWorkNotice = false;
        if ($scope.housingStatus && $scope.currentPolicy && $scope.currentPolicy.housing_policy_name) {
          var currentSubmission = _.find($scope.housingStatus, { housing_policy_name: $scope.currentPolicy.housing_policy_name });
          if (currentSubmission && currentSubmission.submitted && currentSubmission.status === 'Needs Work') {
            $scope.needsWorkNotice = true;
          }
        }
      }
    );

    $scope.$watch('housingStatus', function () {
      $scope.formReadOnly = !$scope.isFormEditable();
    }, true);

    $scope.toggleAdminUnlock = function () {
      $scope.adminUnlocked = !$scope.adminUnlocked;
      $scope.formReadOnly = !$scope.isFormEditable();
    };

    $scope.withdrawSubmission = function () {
      var confirmWithdraw = window.confirm(
        "Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.",
      );
      if (!confirmWithdraw) return;

      var submission = null;
      if ($scope.housingStatus) {
        for (var i = 0; i < $scope.housingStatus.length; i++) {
          if (
            $scope.housingStatus[i].housing_policy_name ===
            $scope.currentPolicy.housing_policy_name
          ) {
            submission = $scope.housingStatus[i];
            break;
          }
        }
      }

      if (!submission || !submission.submission_id) {
        console.error("No matching submission found to withdraw");
        return;
      }

      var payload = {
        submission_id: submission.submission_id,
        submitted: false,
        status: null,
      };

      fetch
        .updateItem("api/data/submissions/update-status", payload)
        .then(function () {
          var matchingPolicy = $scope.currentlySelectedPolicies.find(function (p) {
            return p.housing_policy_name === $scope.currentPolicy.housing_policy_name;
          });
          if (matchingPolicy) {
            matchingPolicy.include_in_submission = false;
          }
          submission.submitted = false;
          submission.status = null;

          if (
            $scope.checkPolicy1 &&
            $scope.checkPolicy1.submission_id === submission.submission_id
          ) {
            $scope.checkPolicy1 = null;
          } else if (
            $scope.checkPolicy2 &&
            $scope.checkPolicy2.submission_id === submission.submission_id
          ) {
            $scope.checkPolicy2 = null;
          }

          // Uncheck the policy in formsSubmitData if it was previously added
          $scope.formsSubmitData = $scope.formsSubmitData.filter(function (p) {
            return p.housing_policy_name !== $scope.currentPolicy.housing_policy_name;
          });

          // Update submit button count label
          $scope.submitType = `Submit Housing Policies for Review (${$scope.formsSubmitData.length})`;

          // Clear form fields — preserve only identity fields
          var policyName = $scope.currentPolicy.housing_policy_name;
          var formId = $scope.currentPolicy.housing_form_id;
          $scope.currentPolicy = { housing_policy_name: policyName, housing_form_id: formId };

          // Show withdrawn notification
          $scope.withdrawnNotice = true;
          $scope.needsWorkNotice = false;
          $scope.success = false;

          $scope.formReadOnly = false;
        })
        .catch(function (err) {
          console.error("Withdraw failed:", err);
          alert(
            "There was an error withdrawing the submission. Please try again.",
          );
        });
    };

    $scope.addToSubmissions = function (policy) {
      $scope.savemode = null;
      if (_.filter($scope.formsSubmitData, { 'housing_policy_name': policy.housing_policy_name }).length === 1) {
        $scope.formsSubmitData = _.remove($scope.formsSubmitData, function (n) {
          return n.housing_policy_name !== policy.housing_policy_name
        })
      } else {
        $scope.formsSubmitData.push(policy);
      }

      $scope.submitmode = 'housing';
      $scope.submitType = `Submit Housing Policies for Review (${$scope.formsSubmitData.length})`;
    }


    $scope.getSubmissionStatus = function () {
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`, `Housing ${$scope.housingType} Policy`)
        .then(response => {
          $scope.housingStatus = response.data;
          $scope.checkPolicy1 = (_.filter(response.data, {
            submission_policy_name: `Affordable Housing ${$scope.housingType} Policy 1`,
            submitted: true
          }))[0];
          console.log($scope.checkPolicy1);
          $scope.checkPolicy2 = (_.filter(response.data, {
            submission_policy_name: `Affordable Housing ${$scope.housingType} Policy 2`,
            submitted: true
          }))[0];
          // Set include_in_submission for already submitted policies
          if ($scope.currentlySelectedPolicies) {
            $scope.currentlySelectedPolicies.forEach(function (policy) {
              if (
                ($scope.checkPolicy1 &&
                  $scope.checkPolicy1.submitted === true &&
                  $scope.checkPolicy1.housing_policy_name === policy.housing_policy_name) ||
                ($scope.checkPolicy2 &&
                  $scope.checkPolicy2.submitted === true && 
                  $scope.checkPolicy2.housing_policy_name === policy.housing_policy_name)
              ) {
                policy.include_in_submission = true;
              } else {
                policy.include_in_submission = false;
              }
            });
          }

        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    $scope.updateSubmissionStatus = function (row, newStatus) {

      if (!row || !row.submission_id) {
        console.error('submission_id is missing:', row);
        return;
      }

      const originalStatus = row.status;

      // Update the UI immediately
      row.status = newStatus;

      const updateData = {
        submission_id: row.submission_id,
        status: newStatus
      };

      console.log('Updating submission:', {
        id: row.submission_id,
        status: newStatus
      });

      fetch.updateItem('api/data/submissions/update-status', updateData)
        .then(response => {
          $timeout(() => {
            $scope.successMessage = 'Status updated successfully';
            // Optional: refresh submission list if needed
          });
        })
        .catch(err => {
          console.error('Error updating status:', err);
          $timeout(() => {
            // Revert the status if update failed
            row.status = originalStatus;
            $scope.error = 'Failed to update status';
          });
        });
    };

    $scope.submitPolicies = function () {
      $scope.saving = true;
      var upsertData = [];

      if ($scope.formsSubmitData.length === 2) {
        for (let index = 0; index < $scope.formsSubmitData.length; index++) {
          var counter = index + 1;
          var data = $scope.formsSubmitData[index];
          $scope.housingStatus.forEach(element => {
            if (element.submission_policy_name === `Affordable Housing ${$scope.housingType} Policy ${counter}` && element.sta_recid === data.sta_recid) {
              element.housing_policy_name = data.housing_policy_name;
              element.submitted = true;
              upsertData.push({
                submission_id: element.submission_id,
                housing_policy_id: data.housing_policy_id,
                submitted: true,
              });
            }
          });
        }
      } else if ($scope.formsSubmitData.length === 1) {
        var data = $scope.formsSubmitData[0];

        if (!$scope.checkPolicy1) {
          $scope.housingStatus.forEach(element => {
            if (element.submission_policy_name === `Affordable Housing ${$scope.housingType} Policy 1` && element.sta_recid === data.sta_recid) {
              element.housing_policy_id = data.housing_policy_id;
              upsertData.push({
                submission_id: element.submission_id,
                housing_policy_id: data.housing_policy_id,
                submitted: true,
              });
            }
          });
        } else if (!$scope.checkPolicy2) {
          $scope.housingStatus.forEach(element => {
            if (element.submission_policy_name === `Affordable Housing ${$scope.housingType} Policy 2` && element.sta_recid === data.sta_recid) {
              element.housing_policy_id = data.housing_policy_id;
              upsertData.push({
                submission_id: element.submission_id,
                housing_policy_id: data.housing_policy_id,
                submitted: true,
              });
            }
          });
        }
      }


      // Uncomment the following to send the upsertData to the API
      fetch.updateItem('api/data/submissions/update', upsertData)
        .then(response => {

          $scope.saved = true;
          $scope.saving = false;
          setTimeout(() => {
            $scope.submitmode = null;
            $scope.saved = false;
            $scope.getSubmissionStatus();
            $scope.$apply();
          }, 3000);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        });
    }


    $scope.updatePoliciesJurisdiction = function (jurisdiction) {
      $scope.currentlySelectedPolicies = [];
      lookup.setJurisdiction(jurisdiction);
      $scope.currentJurisdiction = jurisdiction;
      $scope.getStationbyID();
      $scope.getSubmissionStatus();
    }

    $scope.getStationbyID = function (station) {
      if (station) {
        $scope.currentSelectedStationId = station;
        lookup.setCurrentStation(station);
      }

      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);

      $scope.getSubmissionStatus();
      $scope.currentlySelectedPolicies = [];
      $scope.loadingPolicies = true;
      fetch.getAllItems(`api/data/housing/forms/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}/${$scope.housingType}`)
        .then(response => {

          $scope.currentStation = response.data[0];

          response.data.forEach(element => {
            if (element.policy_selected) {
              $scope.currentlySelectedPolicies.push(element);
            }
          });

          // Check if a specific policy was requested via policyName parameter
          const requestedPolicyName = $stateParams.policyName;
          let policyToSelect = null;

          if (requestedPolicyName && $scope.currentlySelectedPolicies.length > 0) {
            // Try to find the requested policy in the selected policies
            policyToSelect = $scope.currentlySelectedPolicies.find(p =>
              p.housing_policy_name === requestedPolicyName
            );
          }

          // Set the current policy
          if (policyToSelect) {
            // If we found the requested policy, select it
            policyToSelect.active = true;
            $scope.currentPolicy = policyToSelect;
            // console.log('Setting policy from policyName parameter:', $scope.currentPolicy);
            $scope.setCurrentPolicy($scope.currentPolicy);
          } else if ($scope.currentlySelectedPolicies.length > 0) {
            // Otherwise, select the first policy
            $scope.currentlySelectedPolicies[0].active = true;
            $scope.currentPolicy = $scope.currentlySelectedPolicies[0];
            $scope.setCurrentPolicy($scope.currentPolicy);
          }

          // console.log("currently selected policies: ", $scope.currentlySelectedPolicies);
          $scope.housingForms = response.data;
          $scope.loadingPolicies = false;
          $scope.getJurisdictionFundingTier($scope.currentSelectedStationId);
        })
    }

    $scope.updateSelected = function (item) {
      if ($scope.currentlySelectedPolicies.length > 0) {
        $scope.currentlySelectedPolicies.forEach(element => {
          element.active = false;
        });
      }

      if (item.policy_selected) {
        $scope.currentlySelectedPolicies.push(item);
      } else {
        for (var i = 0; i < $scope.currentlySelectedPolicies.length; i++) {
          if ($scope.currentlySelectedPolicies[i].housing_form_id === item.housing_form_id) {
            $scope.currentlySelectedPolicies.splice(i, 1);
          }
        }
      }
      if ($scope.currentlySelectedPolicies.length > 0) {
        $scope.currentlySelectedPolicies[0].active = true;
        $scope.currentPolicy = $scope.currentlySelectedPolicies[0];
      } else {
        $scope.currentPolicy = {};
      }
      var upsertData = {
        policy_selected: item.policy_selected,
        housing_form_id: item.housing_form_id
      }
      fetch.updateItem('api/data/housing/forms/update', upsertData)
        .then(response => {
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }



    $scope.setCurrentPolicy = function (item) {
      if (item === 'reviewAndSubmit') {
        $scope.currentPolicy = {};
        $scope.reviewAndSubmit = true;
        $scope.note = ''; // Clear the note when no specific policy is active
      } else if (!item) {
        //  no policy is actively selected
        $scope.reviewAndSubmit = false;
        $scope.note = '<strong>Note:</strong> Complete two policies in this section for submission to MTC for review.'
      } else {
        $scope.reviewAndSubmit = false;
        $scope.currentPolicy = item;

        if ($scope.policyNotesMapping.hasOwnProperty(item.housing_policy_name)) {
          $scope.note = $scope.policyNotesMapping[item.housing_policy_name];
        } else {
          $scope.note = '<strong>Note:</strong> A jurisdiction must enter information for all fields for each affordable housing production policy they are using to demonstrate TOC Policy compliance. If any field is not relevant to a jurisdiction, enter “N/A".'
        }
      }
    }

    $scope.getStationAreaList = function (jurisdiction) {
      // Check for the sta_recid parameter from $stateParams
      const staRecId = $stateParams.sta_recid;
      lookup.setJurisdiction(jurisdiction);
      fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
        .then(response => {
          $scope.stationAreas = response.data;

          if (staRecId) {
            $scope.currentSelectedStationId = staRecId; // Set currentSelectedStationId from sta_recid
          } else if (lookup.getCurrentStation()) {
            $scope.currentSelectedStationId = lookup.getCurrentStation(); // Fallback to lookup service
          } else {
            $scope.currentSelectedStationId = $scope.stationAreas[0].sta_recid;
          }

          lookup.setCurrentStation($scope.currentSelectedStationId);

          // Call getStationbyID() after setting the currentSelectedStationId
          $scope.getStationbyID();
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        });
    };

    $scope.updateCurrentPolicy = function (form) {
      $scope.formSubmitted = true;
      $scope.form = form;
      $scope.saving = true;
      if ($scope.currentPolicy.active) {
        delete $scope.currentPolicy.active;
      }

      console.log('Saving currentPolicy:', angular.copy($scope.currentPolicy));

      fetch.updateItem('api/data/housing/forms/update', $scope.currentPolicy)
        .then(response => {

          $scope.saving = false;
          $scope.saved = true;
          $scope.pendingChanges = false;
          setTimeout(() => {
            $scope.savemode = null;
            $scope.saved = false;
            $scope.currentPolicy.active = true;
            $scope.$apply();
          }, 4000);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }



    $scope.getHousingForm = function () {
      // First, ensure there's a selected or current policy to work with 
      const currentPolicy = $scope.currentPolicy

      if (currentPolicy && currentPolicy.housing_form_id) {
        // Fetch housing forms data (not policy names) based on the selected policy
        fetch.getAllItems(`api/data/getForm/${currentPolicy.housing_form_id}`)
          .then(response => {
            $scope.currentPolicy = response.data[0];
            // Initialize or ensure initialization of attachment-related properties
            //    if (!$scope.currentPolicy.secured_funding_docs) {
            //     $scope.currentPolicy.secured_funding_docs = {
            //         text: '',
            //         fileName: null,
            //         file: null,
            //         isFileSelected: false
            //     };
            // }
          })

          .catch(error => {
            console.error('Error fetching currentPolicy for the current policy:', error);
            // Handle fetching errors by resetting currentPolicy or display an error
            $scope.currentPolicy = {};
          });
      } else {
        console.warn('current policy is not defined or is missing a housing_form_id.');
        // Lastly, handle a case where currentPolicy hasn't been set or lacks necessary information
        $scope.currentPolicy = {} // reset or provide default form data 
      }
    }

    // File upload functions 

    // $scope.initializeField = function (fieldId) {
    //   if (!$scope.attachmentData[fieldId]) {
    //     $scope.attachmentData[fieldId] = {
    //       fileName: null,
    //       file: null,
    //       isFileSelected: false
    //     };
    //   }
    // };

    // Function to open the file dialog
    // $scope.openFileDialog = function (fieldId) {
    //   console.log(fieldId)
    //   $timeout(function () {
    //     document.getElementById('fileInput' + fieldId).click();
    //   }, 0);
    // };

    // Function to handle file changes
    // $scope.fileChanged = function (fieldId, element) {
    //   console.log(fieldId);
    //   console.log(element);
    //   $scope.initializeField(fieldId);  // Ensure field is initialized

    //   var file = element.files[0];
    //   if (file) {
    //     // Check if the file type is PDF, Word document, or Excel file
    //     if (
    //       file.type !== 'application/pdf' &&
    //       file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && // For .docx
    //       file.type !== 'application/msword' && // For .doc
    //       file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && // For .xlsx
    //       file.type !== 'application/vnd.ms-excel' // For .xls
    //     ) {
    //       alert('Please select a PDF, Word document, or Excel file.');
    //       element.value = ''; // Reset input to clear the wrong file type
    //       return;
    //     }

    //     $scope.attachmentData[fieldId].fileName = file.name;
    //     $scope.attachmentData[fieldId].file = file;
    //     $scope.attachmentData[fieldId].isFileSelected = true;

    //     $scope.$apply();
    //   }
    // };
    $scope.selectedFile = null;

    $scope.handleFileSelect = function (element) {
      console.log(element);
      $scope.setPending();
      $scope.$apply(function () {
        $scope.selectedFile = element.files[0];
      });
    };

    $scope.uploadFile = function (ngmodelfile) {
      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
      console.log(ngmodel);

      // Use the stored selectedFile instead of getting it from DOM
      var file = $scope.selectedFile;

      if (!file) {
        console.error('No file selected');
        return;
      }

      $scope[`fileUploading_${ngmodelfile}`] = true;

      var fileUpload = {
        fileName: file.name,
        fileType: file.type
      };

      // Rest of your upload logic remains the same
      fetch.updateItem('api/data/get-signed-url', fileUpload)
        .then(response => {
          console.log('Signed URL:', response.data.signedUrl);
          console.log('Public URL:', response.data.publicUrl);

          return $http({
            method: 'PUT',
            url: response.data.signedUrl,
            data: file,
            headers: {
              'Content-Type': file.type,
            }
          })
            .then(() => {
              $scope.currentPolicy[ngmodel] = response.data.publicUrl;
              return response.data.publicUrl;
            });
        })
        .then(publicUrl => {
          console.log('Upload successful');
          console.log('Public URL:', publicUrl);

          $scope[`fileUploading_${ngmodelfile}`] = false;
          $scope[`${ngmodelfile}`] = '';
          $scope.clearFile(ngmodelfile);
          $scope.uploadSuccess = true;
          $scope.selectedFile = null; // Clear the selected file
        })
        .catch(error => {
          console.error('Error:', error);
          alert('Upload failed');
          $scope[`fileUploading_${ngmodelfile}`] = false;
        });
    };

    $scope.clearFile = function (ngmodelfile) {
      const fileInput = document.getElementById(ngmodelfile);
      if (fileInput) {
        fileInput.value = '';
        $scope.selectedFile = null;
      }
    };

    $scope.checkSubstring = function (input) {
      return input && input.length >= 4 && input.substring(0, 4) === 'http';
    };

    $scope.removeFile = function (ngmodel) {
      console.log(ngmodel);
      $scope.currentPolicy[ngmodel] = '';
      $scope.setPending();
      $scope.savemode = 'housing';
      $scope.pendingChanges = true;
    };


    // End file upload functions 

    $scope.getJurisdictionFundingTier = function (station) {
      if (station) {
        $scope.loadingData = true;
      }
      fetch.getItem(`api/data/housing/fundingtiers/${$scope.currentJurisdiction}`, $scope.currentSelectedStationId)
        .then(response => {
          $scope.fundingLevels = response.data[0];
          $scope.loadingData = false;
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    };
  };

  $onInit() {
    this.userService.getCurrentUser()
      .then(response => {
        this.$scope.currentUser = response.data;
        this.userService.setCurrentUser(response.data);
        this.$scope.housingForms = [];
        this.$scope.getJurisdictionFundingTier();
        return this.getJurisdictionList();


      })
      .catch(err => {
        console.log(err);
        if (err.status === 403) {
          this.$state.go('login');
        }
      })
    // this.$scope.note = '<strong>Note:</strong> A jurisdiction must enter information for all fields for each affordable housing protection policy they are using to demonstrate TOC Policy compliance. If any field is not relevant to a jurisdiction, enter “N/A."';


  }

  getJurisdictionList() {
    this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list')
      .then(response => {
        this.$scope.loading = false;
        this.$scope.jurisdictions = response.data;

        // Check if user role is Administrator
        if (this.$scope.currentUser.role === 'Administrator') {
          console.log("admin");
          // Check for the jurisdiction parameter in the URL
          const jurisdictionParam = this.$stateParams.jurisdiction;
          console.log(this.$stateParams);
          if (jurisdictionParam) {
            this.$scope.currentJurisdiction = jurisdictionParam;
          } else if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        } else {
          if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        }

        console.log(this.$scope.currentJurisdiction);
        this.lookup.setJurisdiction(this.$scope.currentJurisdiction);
        this.$scope.getStationAreaList(this.$scope.currentJurisdiction);
        // this.$scope.getJurisdictionFundingTier(this.$scope.currentJurisdiction);
      })
      .catch(err => {
        console.log(err);
      });
  }

  updateSelected(item) {
    if (this.$scope.currentlySelectedPolicies.length > 0) {
      this.$scope.currentlySelectedPolicies.forEach(element => {
        element.active = false;
      });
    }

    if (item.policy_selected) {
      this.$scope.currentlySelectedPolicies.push(item);
    } else {
      for (var i = 0; i < this.$scope.currentlySelectedPolicies.length; i++) {
        if (this.$scope.currentlySelectedPolicies[i].housing_form_id === item.housing_form_id) {
          this.$scope.currentlySelectedPolicies.splice(i, 1);
        }
      }
    }
    if (this.$scope.currentlySelectedPolicies.length > 0) {
      this.$scope.currentlySelectedPolicies[0].active = true;
      this.$scope.currentPolicy = this.$scope.currentlySelectedPolicies[0];
    } else {
      this.$scope.currentPolicy = {};
    }
    var upsertData = {
      policy_selected: item.policy_selected,
      housing_form_id: item.housing_form_id
    }

    this.fetch.updateItem('api/data/housing/forms/update', upsertData)
      .then(response => {
      })
      .catch(err => {
        console.log(err);
        if (err.status === 403) {
          this.$state.go('login');
        }
      })
  }

  getStationAreaSubmissionSummary(stationId) {
    console.log('Getting summary for station:', stationId);
    this.lookup.setCurrentStation(stationId);

    if (this.$scope.stationAreas.length > 0) {
      this.$scope.stationAreas.forEach(element => {
        element.active = element.sta_recid === stationId;
        if (element.active) {
          this.$scope.stationAreaTitle = element.station_name;
        }
      });

      return this.fetch.getItem(
        `api/data/policies/${this.$scope.currentJurisdiction}`,
        stationId
      )
        .then(response => {
          console.log('Policy data:', response);
          this.$scope.submissionSummary = response.data;
          console.log("submission summary: ", this.$scope.submissionSummary);
          this.lookup.setSubmissionPolicies(this.$scope.submissionSummary);

          // Process density submissions
          this.$scope.densitySubmissions = _.filter(response.data,
            { submission_policy_type: "Density" });
          this.$scope.densitySubmitted = _.filter(this.$scope.densitySubmissions,
            { submitted: true });
          this.$scope.densityCompliant = _.filter(this.$scope.densitySubmissions,
            { status: 'Consistent' });

          // Process housing policy submissions
          this.$scope.housingPolicySubmissions = _.filter(response.data,
            { submission_policy_type: "Housing Production Policy" });
          this.$scope.housingPolicySubmissions = _.union(
            this.$scope.housingPolicySubmissions,
            _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" })
          );
          this.$scope.housingPolicySubmitted = _.filter(
            this.$scope.housingPolicySubmissions,
            { submitted: true }
          );
          this.$scope.housingPolicyCompliant = _.filter(
            this.$scope.housingPolicySubmissions,
            { status: 'Consistent' }
          );

          // Process parking submissions
          this.$scope.parkingSubmissions = _.filter(response.data,
            { submission_policy_type: "Parking" });
          this.$scope.parkingSubmitted = _.filter(this.$scope.parkingSubmissions,
            { submitted: true });
          this.$scope.parkingCompliant = _.filter(this.$scope.parkingSubmissions,
            { status: 'Consistent' });

          // Process station access submissions
          this.$scope.stationAccessSubmissions = _.filter(response.data,
            { submission_policy_type: "Station Area Access" });
          this.$scope.stationAccessSubmitted = _.filter(
            this.$scope.stationAccessSubmissions,
            { submitted: true }
          );
          this.$scope.stationAccessCompliant = _.filter(
            this.$scope.stationAccessSubmissions,
            { status: 'Consistent' }
          );
        });

      this.$scope.loading = false;
    } else {
      this.$scope.stationAreaTitle = '--';
      return Promise.resolve();
    }
  }


};

export default angular.module('appApp.housing_protection', [uiRouter])
  .config(routes)
  .component('housingProtection', {
    template: require('./housing_protection.html'),
    controller: HousingProtectionComponent,
    controllerAs: 'housingProtectionCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/housing/housing_protection/housing_protection.component.js